import { ConcertService } from '../../../../services/app/concert.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'concert-main',
  templateUrl: './concert-main.component.html',
  styleUrls: ['./concert-main.component.css'],
})
export class ConcertMainComponent implements OnInit {
  public concertGroupedSeoUrl: string;
  constructor(
    public concertService: ConcertService,
    public acRoute: ActivatedRoute
  ) {
    this.concertGroupedSeoUrl = this.acRoute.snapshot.paramMap.get(
      'concertGroupedSeoUrl'
    );
  }

  async ngOnInit() {
    if (this.concertService.concerts$.value == null)
      await this.concertService.getConcertData();
    if (this.concertGroupedSeoUrl)
      this.concertService.concerts$.next(
        this.concertService.concertsPure$.value.filter(
          (concert) =>
            this.concertService.seoUrlGenerate(concert.GROUPNAME) ==
            this.concertGroupedSeoUrl
        )
      );
  }
  breadBack() {
    window.history.back();
  }
}
